/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idPlantaoVendas: string | undefined | null;
  codigoTurno: string | number;
  quantidadePosicoes: string;
}

export function useIniciarInscricao() {
  const postData = async (props: Props) => {
    const INICIAR_INSCRICAO = `${leadsWebEnviroment}/common/checkin/recepcao/iniciar-inscricao/v1`;
    const response = await instance.post(INICIAR_INSCRICAO, {
      idPlantaoVendas: props.idPlantaoVendas,
      codigoTurno: props.codigoTurno,
      quantidadePosicoes: Number(props.quantidadePosicoes),
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
